import { render, staticRenderFns } from "./consent-banner.vue?vue&type=template&id=12f7bf1e&scoped=true"
import script from "./consent-banner.vue?vue&type=script&setup=true&lang=js"
export * from "./consent-banner.vue?vue&type=script&setup=true&lang=js"
import style0 from "./consent-banner.vue?vue&type=style&index=0&id=12f7bf1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f7bf1e",
  null
  
)

export default component.exports